import Head from "next/head";
import languages from "config/languages";
import getDomainFromLanguage from "utils/getDomainFromLanguage";
import type { SchemaProps } from "./Schema.d";

const Schema = ({
  language,
  title = "",
  description = "",
  keywords = "",
  canonical,
  cmsPageSchema = "",
  datePublished,
  dateModified,
}: SchemaProps) => {
  const domain = getDomainFromLanguage(language);

  const generalSchema = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    "@id": `${domain}/${canonical}#webpage`,
    url: `${domain}/${canonical}`,
    inLanguage: languages.get(language).hreflang,
    name: title,
    description,
    keywords,
    datePublished,
    dateModified,
    isPartOf: {
      "@type": "WebSite",
      "@id": `${domain}/${language}/#website`,
      url: `${domain}/${language}/`,
      name: "AirHelp",
    },
  };

  return (
    <Head>
      <script type="application/ld+json">{JSON.stringify(generalSchema)}</script>
      {cmsPageSchema && <script type="application/ld+json">{cmsPageSchema}</script>}
    </Head>
  );
};

export default Schema;
